import { useState } from "react"

export default function UIServicesOutControls({ className, onPrev, onNext, index, total }) {
    const [hoverPrev, setHoverPrev] = useState(false)
    const [hoverNext, setHoverNext] = useState(false)

    return (
        <div className={`flex gap-7 py-4 ${className}`}>
            <div onClick={onPrev} onMouseOver={() => { setHoverPrev(true) }} onMouseLeave={() => { setHoverPrev(false) }}
                className="h-[50px] transition-all cursor-pointer items-center justify-center flex w-[50px] rounded-full border border-white hover:bg-emerald-400">
                <svg width="10" height="19" viewBox="0 0 10 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M8.66211 17.912L1.2547 9.57872L8.66211 1.24538" stroke={hoverPrev ? 'white' : '#ffffff'} />
                </svg>
            </div>
            <div onClick={onNext} onMouseOver={() => { setHoverNext(true) }} onMouseLeave={() => { setHoverNext(false) }}
                className="h-[50px] transition-all cursor-pointer items-center justify-center flex w-[50px] rounded-full border border-white hover:bg-emerald-400">
                <svg width="10" height="19" viewBox="0 0 10 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1.33789 17.912L8.7453 9.57872L1.33789 1.24538" stroke={hoverNext ? 'white' : '#ffffff'} />
                </svg>
            </div>
        </div>
    )
}